"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { BrandLoadingState } from "@/components/ui/brand-loading-state";
import { useCountrySettings } from "@/hooks/use-app-country";

export const WaitingPage = () => {
	const router = useRouter();
	const [showText, setShowText] = useState(false);
	const [textIndex, setTextIndex] = useState(0);
	const t = useTranslations("pages.WaitingPage");
	const yellowStateUri = useCountrySettings().receiptUrls.yellow;

	const texts = [
		t("text1"),
		t("text2"),
		t("text3"),
		t("text4"),
		t("text5"),
		t("text6"),
		t("text7"),
		t("text8"),
	];

	useEffect(() => {
		const textTimer = setTimeout(() => {
			setShowText(true);
			const cycleInterval = setInterval(() => {
				setTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
			}, 5000);

			return () => clearInterval(cycleInterval);
		}, 5000);

		return () => clearTimeout(textTimer);
	}, [texts.length]);

	useEffect(() => {
		const fiveMinutes = 1000 * 60 * 5;
		const waitingPageTimeout = setTimeout(() => {
			router.push(yellowStateUri);
		}, fiveMinutes);

		return () => clearTimeout(waitingPageTimeout);
	}, [router, yellowStateUri]);

	return <BrandLoadingState text={showText ? texts[textIndex] : texts[0]} />;
};
